import {ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {SVGItems, svgNames} from '../../../../shared/components/svg/svgItems';
import {EventType} from '../models/EventType';

@Component({
  selector: 'app-event-type',
  templateUrl: './event-type.component.html',
  styleUrls: ['./event-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class EventTypeComponent implements OnInit {

  @Input()
  type: EventType;

  SVG_NAMES: SVGItems = svgNames;

  eventTypeMapper: any = {};

  constructor() {
  }

  ngOnInit(): void {
    this.initEventTypeMapper();
  }

  private initEventTypeMapper() {
    this.eventTypeMapper[EventType.controllers] = {
      type: 'svg',
      key: this.SVG_NAMES.controllers,
      text: 'Controllers'
    };
    this.eventTypeMapper[EventType.firewall] = {
      type: 'svg',
      key: this.SVG_NAMES.access_firewall,
      text: 'Access Firewall'
    };
    this.eventTypeMapper[EventType.lockdown] = {
      type: 'svg',
      key: this.SVG_NAMES.lock_shield,
      text: 'Lockdown'
    };
    this.eventTypeMapper[EventType.system] = {
      type: 'font',
      key: 'system',
      text: 'System'
    };
    this.eventTypeMapper[EventType.fingerprint] = {
      type: 'font',
      key: 'fingerprint',
      text: 'Finger Print'
    };
    this.eventTypeMapper[EventType.camera] = {
      type: 'font',
      key: 'camera',
      text: 'Camera'
    };
    this.eventTypeMapper[EventType.alert] = {
      type: 'font',
      key: 'warning',
      text: 'Alert'
    };
  }

}
